// extracted by mini-css-extract-plugin
export default {"mainContainer":"SignUp_mainContainer__-qOZ-","mainHeading":"SignUp_mainHeading__CIOe9"};